export default __webpack_public_path__ + "static/media/think4.760bb43c.png";